import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import isSameMonth from 'date-fns/isSameMonth'
import { CloseStoreCalendar, CloseStoreCalendarLabel, CloseStoreArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { StoreCalendarType } from 'types/storeCalendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreCurrentMonth } from 'reducks/storeCalendar/selectors'

type Props = {
  handleStoreCalendars: (storeCalendar: StoreCalendarType) => void
  storeCalendars: StoreCalendarType[]
}

const CloseStoreCalendarContainer: FC<Props> = (props) => {
  const { handleStoreCalendars, storeCalendars } = props
  const currentMonth = useSelector((state: State) => getStoreCurrentMonth(state))

  return (
    <div>
      <div className={styles.calendar__monthly__header}>
        {!isSameMonth(currentMonth, new Date()) && <CloseStoreArrowButton label={'前月'} type={'prev'} />}
        <CloseStoreCalendarLabel currentMonth={currentMonth} />
        <CloseStoreArrowButton label={'翌月'} type={'next'} />
      </div>
      <Spacer size={16} />
      <CloseStoreCalendar handleStoreCalendars={handleStoreCalendars} storeCalendars={storeCalendars} />
    </div>
  )
}

export default CloseStoreCalendarContainer
